import { createSlice,PayloadAction } from "@reduxjs/toolkit";
import MgpStore from "./Store";

export interface IdntMthdCdSetSetStateDataType {
    IdntMthdCd:string
}
const initialState:IdntMthdCdSetSetStateDataType  = {
    IdntMthdCd:""
}

const IdntMthdCdSetSlice = createSlice({
    name:"IdntMthdCdSet",
    initialState,
    reducers: {
        IdntMthdCdStateChng(state,action:PayloadAction<string>) {
            state.IdntMthdCd = action.payload;
        }
    }
});
export type AppDispatch = typeof MgpStore.dispatch;
export const {IdntMthdCdStateChng} = IdntMthdCdSetSlice.actions;
export default IdntMthdCdSetSlice.reducer;
